import { render, staticRenderFns } from "./rejectApprovedTicket.vue?vue&type=template&id=16701a7e&lang=pug"
import script from "./rejectApprovedTicket.vue?vue&type=script&lang=js"
export * from "./rejectApprovedTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports